import React, { useState } from "react";
import TauriImage from "../../../TauriImage/TauriImage";
import "./TauriSidebarFilterPlanning.css";

const TauriSidebarFilterPlanning = ({ }) => {
    return (
        <div className="sidebar-filter-planning">
            <div className="btn-select d-flex align-items-center">
                <TauriImage localImage={"/Images/octicon--duplicate-24.svg"} alt="icon" className={"pl-images"} color={"#626262"} />
                <div>Duplicate</div>
            </div>
            <div className="btn-select d-flex align-items-center">
                <TauriImage localImage={"/Images/outline-auto-awesome.svg"} alt="icon" className={"pl-images"} color={"#FD9B1B"} />
                <div>Auto</div>
            </div>
            <div className="btn-select d-flex align-items-center">
                <TauriImage localImage={"/Images/symbols--search.svg"} alt="icon" className={"pl-images"} color={"#049D33"}/>
                <div>Search</div>
            </div>
            <div className="btn-select d-flex align-items-center">
                <TauriImage localImage={"/Images/iconoir--submit-document.svg"} alt="icon" className={"pl-images"} color={"#049D33"} />
                <div>Submit</div>
            </div>
        </div>
    );
};

export default TauriSidebarFilterPlanning;
